import { fmtQty, koboToNaira } from '../lib/format';

export interface PositionRow {
  accountId: string;
  symbol: string;
  quantity: number;
  averagePrice: string;
  marketValue: string;
  unrealizedPnl: string;
}

export function PositionsTable({ rows }: { rows: PositionRow[] }) {
  return (
    <div className="panel">
      <h3>Positions</h3>
      {rows.length === 0 ? (
        <div className="hint">No open positions.</div>
      ) : (
        <table className="mono">
          <thead>
            <tr>
              <th>Symbol</th>
              <th style={{ textAlign: 'right' }}>Qty</th>
              <th style={{ textAlign: 'right' }}>Avg</th>
              <th style={{ textAlign: 'right' }}>Mkt Val</th>
              <th style={{ textAlign: 'right' }}>Unrealised PnL</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={`${r.accountId}|${r.symbol}`}>
                <td>{r.symbol}</td>
                <td style={{ textAlign: 'right' }}>{fmtQty(r.quantity)}</td>
                <td style={{ textAlign: 'right' }}>{koboToNaira(r.averagePrice)}</td>
                <td style={{ textAlign: 'right' }}>{koboToNaira(r.marketValue)}</td>
                <td style={{ textAlign: 'right' }} className={Number(r.unrealizedPnl) >= 0 ? 'up' : 'down'}>
                  {koboToNaira(r.unrealizedPnl)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
